import React from "react";
import axios from "axios";
import {useQuery} from "@tanstack/react-query";
import { EventListItem } from "./EventListItem";
import { ListItemContainer } from "../../utils/common-styles";
import {LoadingEventListItem} from "../../components/Extra/Loading/LoadingEventListItem";

const fetchEvents = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/events/list`);
    return response.data.payload.events;
}

export const EventsList = () => {

    const {isLoading, error, data: events} = useQuery({
        queryKey: ['events'],
        queryFn: fetchEvents
    });

    return (
        <section>
            <div className="event-list-two">
               <ListItemContainer>  
                    
                    {error && <p style={{color: "red"}}>An error has occurred. Please try again later.</p>}
                    {isLoading && Array.from({ length: 10 }).map((_, index) => (
                        <LoadingEventListItem key={index} />
                    ))}
                    {!isLoading && events.map((event, index) => (
                        <EventListItem key={index} event={event} />
                    ))}
               </ListItemContainer>
            </div>
        </section>
    );
}